<template>
  <div>
    <div class="row p-1">
      <div class="col-12 col-md-3">
        <b-form-group label="Ngày đăng" class="mb-0">
          <date-picker v-model="loadDateRange" type="datetime" range ref="datetime" :shortcuts="shortcuts"
            :show-time-panel="false" format='DD/MM/YYYY' valueType="format" input-class="form-control"
            placeholder="dd/mm/yyyy - dd/mm/yyyy"></date-picker>
        </b-form-group>
      </div>

      <b-col class="col-12 col-md-6 mt-1 mt-md-0">
        <b-form-group label="Từ khóa" class="mb-0">
          <b-input-group label="Tiêu đề">
            <b-form-input v-model="keyword" class="d-inline-block" placeholder="Nhập nội dung..." />
            <b-input-group-append>
              <b-button variant="danger" @click="excellentSearchQuery">
                <feather-icon icon="SearchIcon" />
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </div>
    <div class="row pb-2">
      <b-col cols="12">
        <b-table ref="refListTable" class="table-responsive table-nowrap" :items="itemsData" responsive
          :fields="tableColumns" primary-key="id" show-empty empty-text="Không tìm thấy bản ghi nào">
          <template #cell(title)="data">
            <p style="white-space:break-spaces">{{ data.item.title }}</p>
          </template>
          <template #cell(excellent)="data">
            <b-form-checkbox :checked="data.item.excellent ? true : false" class="custom-control-success"
              name="check-button" switch @input="updateStatus(data.item)" />
          </template>
        </b-table>
      </b-col>
      <b-col cols="12" class="d-flex align-items-center justify-content-center">
        <b-pagination v-model="currentPage" :total-rows="total" :per-page="perPage" first-number last-number
          class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
      </b-col>
    </div>
  </div>
</template>
<script>

import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BLink, BFormCheckbox,
  BPagination, BInputGroupAppend, BInputGroup, BFormGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import {
  ref, watch, computed,
} from '@vue/composition-api'
import store from '@/store'
import useJwt from '@/auth/jwt/useJwt';
import { showToast } from '@/@core/utils/utils';
import flatPickr from 'vue-flatpickr-component'
import { Vietnamese } from 'flatpickr/dist/l10n/vn'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/vi';
import moment from 'moment';
export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BLink,
    BPagination,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BFormGroup,
    vSelect,
    flatPickr,
    DatePicker
  },
  data() {
    return {
      moment,
    }
  },
  watch: {
    loadDateRange(newDate, oldDate) {
      this.start_date = (newDate[0]) ? newDate[0] : ''
      this.end_date = (newDate[1]) ? newDate[1] : ''
      this.$refs.datetime.closePopup()
    },
  },
  setup(props, context) {
    const refListTable = ref(null)
    const dataUser = useJwt.getUser();
    const now = new Date()
    // console.log('props', props)
    const tableColumns = [
      { key: 'id', sortable: false, class: 'itemid' },
      { key: 'title', sortable: false, label: 'Tiêu đề', },
      { key: 'published_at', sortable: false, label: 'Ngày xuất bản', thAttr: { width: '12%' }, },
      {
        key: 'excellent', sortable: false, label: '', thAttr: { width: '12%' }, class: 'text-center',
      },
    ];

    const perPage = ref(10)
    const total = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const type = ref('')
    const keyword = ref('')
    const itemsData = ref([]);
    const start_date = ref('')
    const end_date = ref('');
    const loadDateRange = ref('')

    const fetchAll = () => {
      store.dispatch('article/fetchAll', {
        keyword: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        type: type.value,
        card_type: 'published',
        excellent: '',
        start_date: start_date.value,
        end_date: end_date.value,
      })
        .then(response => {
          const result = response.data;
          if (result.code === 200) {
            itemsData.value = result.data.data
            total.value = result.data.total;
          }
        })
    }
    const dataMeta = computed(() => {
      const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0
      return {
        from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
        to: perPage.value * (currentPage.value - 1) + localItemsCount,
        of: total.value,
      }
    })

    watch([currentPage, perPage, searchQuery], () => {
      refetchData()
    })

    const refetchData = () => {
      fetchAll()
    }

    const excellentSearchQuery = () => {
      searchQuery.value = keyword.value
      if (start_date.value && start_date.value > end_date.value) {
        showToast('Đến ngày phải lớn hơn từ ngày');
        return false;
      }
      refetchData()
    }
    const shortcuts = ref([
      { text: 'Hôm nay', onClick: () => [new Date(), new Date()] },
      { text: 'Hôm qua', onClick: () => [new Date(Date.now() - 3600 * 1000 * 24), new Date()] },
      { text: 'Tuần trước', onClick: () => [new Date(Date.now() - 7 * 24 * 3600 * 1000), new Date()] },
      { text: 'Tháng hiện tại', onClick: () => [new Date(now.getFullYear(), now.getMonth(), 1), new Date(now.getFullYear(), now.getMonth() + 1, 0)] },
      { text: 'Tháng trước', onClick: () => [moment().subtract(1, 'months').startOf('month').toDate(), moment().subtract(1, 'months').endOf('month').toDate()] },
      { text: 'Năm hiện tại', onClick: () => [moment().startOf('year').toDate(), moment().endOf('year').toDate()] }
    ])
    fetchAll()
    return {
      tableColumns,
      perPage,
      currentPage,
      total,
      dataMeta,
      perPageOptions,
      refListTable,
      refetchData,
      excellentSearchQuery,
      keyword,
      itemsData,
      dataUser,
      start_date,
      end_date,
      shortcuts
    }
  },
  methods: {
    updateStatus(item) {
      const data = { type: 'excellent', id: item.id };
      store.dispatch('article/active', data).then(response => {
        const result = response.data;
        if (result.code === 200) {
          this.$emit('updateExcellent')
          showToast(result.message, { variant: 'success' });
        } else {
          showToast(result.message);
        }
      })
    },
  },
}
</script>
<style lang="scss">
#modalState {
  .modal-dialog {
    max-width: 70% !important;
  }
}

@media (max-width: 768px) {
  #modalState .modal-dialog {
    max-width: 100% !important;

    .pt-sm-1 {
      padding: 0;
      margin-top: 0.5rem
    }

    .ml-1 {
      margin: 0 !important;

    }
  }
}

@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
